/**
 * French Proper Nouns - Should NOT be translated when locale is French
 *
 * These are region names, sector names, and other proper nouns that appear
 * in data but should pass through untranslated when the app is in French.
 */

// French administrative regions
export const FRENCH_REGIONS = [
  'Auvergne-Rhône-Alpes',
  'Bourgogne-Franche-Comté',
  'Bretagne',
  'Centre-Val de Loire',
  'Corse',
  'Grand Est',
  'Grand-Est',
  'Hauts-de-France',
  'Île-de-France',
  'Normandie',
  'Nouvelle-Aquitaine',
  'Occitanie',
  'Pays de la Loire',
  'Provence-Alpes-Côte d\'Azur',
  'PACA',
  // Overseas regions
  'Guadeloupe',
  'Martinique',
  'Guyane',
  'La Réunion',
  'Mayotte',
] as const;

// Common sector names in French
export const FRENCH_SECTORS = [
  'Agriculture & Bio',
  'Agriculture',
  'Bio',
  'Agroalimentaire',
  'Artisanat',
  'BTP',
  'Commerce',
  'Conseil & Accompagnement',
  'Création d\'entreprise',
  'Culture',
  'Digital',
  'Économie Circulaire',
  'Économie circulaire',
  'Énergie & Environnement',
  'Énergie',
  'Environnement',
  'Export & Commerce',
  'Export',
  'Formation',
  'Hôtellerie-Restauration',
  'Immobilier',
  'Industrie',
  'Innovation & R&D',
  'Innovation',
  'R&D',
  'Numérique',
  'Recherche & Développement',
  'Santé',
  'Services',
  'Social',
  'Tourisme',
  'Transport',
  'Transition Écologique',
  'Transition écologique',
] as const;

// Check if a string is a French proper noun
export function isFrenchProperNoun(text: string): boolean {
  return (
    FRENCH_REGIONS.some(region => region === text || region.toLowerCase() === text.toLowerCase()) ||
    FRENCH_SECTORS.some(sector => sector === text || sector.toLowerCase() === text.toLowerCase())
  );
}

// Check if a string is a French region
export function isFrenchRegion(text: string): boolean {
  return FRENCH_REGIONS.some(region => region === text || region.toLowerCase() === text.toLowerCase());
}

// Check if a string is a French sector
export function isFrenchSector(text: string): boolean {
  return FRENCH_SECTORS.some(sector => sector === text || sector.toLowerCase() === text.toLowerCase());
}
